const ACTIVE_STATUS = 'Ativo';
const TRAINING_CENTER_COMPANY_TYPE = 'Centro de Treinamento';

const isAllowedOverviewCenter = (trainingCenter) => {
  const status = trainingCenter?.Status ?? trainingCenter?.status;
  const companyType = trainingCenter?.CompanyType ?? trainingCenter?.companyType;
  return status === ACTIVE_STATUS && companyType === TRAINING_CENTER_COMPANY_TYPE;
};

export const toAllowedOverviewCenters = (trainingCenters) => {
  if (!Array.isArray(trainingCenters)) {
    return [];
  }

  return trainingCenters.filter(isAllowedOverviewCenter);
};

export const intersectPersistedCenterIds = (persistedIds, allowedIds) => {
  if (!Array.isArray(allowedIds) || allowedIds.length === 0) {
    return [];
  }

  if (!Array.isArray(persistedIds) || persistedIds.length === 0) {
    return [...allowedIds];
  }

  const allowedIdSet = new Set(allowedIds);
  return persistedIds.filter((persistedId) => allowedIdSet.has(persistedId));
};
